import styled, { keyframes } from 'styled-components';
import * as palette from '../../styles/variables';
import { Icon } from 'antd';
import {
  DEFAULT_FONT,
  WHITE_COLOR,
  BLACK_COLOR,
  LIGHT_RED,
  DARK_RED,
  LIGHT_GREEN,
  DARK_GREEN,
  LIGHT_BLUE,
  DARK_BLUE,
} from '../../styles/variables';

export const Container = styled.div`
  width: 100%;
  height: 100%;
  transition: width 0.3s ease-in-out;

  &.expand {
  }

  &.collapse {
    width: 75%;
  }
`;

export const Main = styled.div`
  background-color: ${WHITE_COLOR};
  height: 100vh;
  width: calc(100vw - 5%);
  margin-left: 5%;
  box-sizing: border-box;
  font-family: ${DEFAULT_FONT}, sans-serif;
  font-weight: 500;
  color: ${BLACK_COLOR};
  display: flex;

  .batchList {
    height: 80vh;
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    padding: 24px;
    row-gap: 24px;
    column-gap: 24px;
    justify-content: flex-start;
    overflow-y: auto;

    &.collapse {
      .anticon.anticon-arrow-up {
        right: 23%;
      }
    }

    &.expand {
      width: 100%;
    }

    .fade-enter {
      opacity: 0;
      transform: translateX(100%);
    }
    .fade-enter-active {
      opacity: 1;
      transform: translateX(0%);
    }
    .fade-exit {
      opacity: 1;
      transform: translateX(0%);
    }
    .fade-exit-active {
      opacity: 0;
      transform: translateX(-100%);
    }
    .fade-enter-active,
    .fade-exit-active {
      transition: opacity 300ms, transform 300ms;
    }

  }

  .customHeight {
    height: 100%;
  }

  .flexCenter {
    justify-content: center;
  }
`;

export const Header = styled.div`
  height: ${props => props.height};
  width: 100%;
  align-items: center;
  display: flex;
  justify-content: ${props => props.justifyContent};
  position: relative;
  transition: 300ms ease width;
  padding: ${props => props.padding};
  cursor: ${props => props.isLoading ? "not-allowed" : "all"};
  z-index: 2;
  .title {
    position: absolute;
    top: 30%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 50px;
    font-weight: 400;
    color: #000;
    font-family: ${palette.FONT_FAMILY_TEMPLATE};
    font-family: ${palette.FONT_FAMILY_TEMPLATE};
    @media (max-width: 800px) {
      top: auto;
      bottom: 0;
      font-size: 2.4rem;
    }
    @media (max-width: 600px) {
      font-size: 6vw;
    }
  }
  .overlayScreenTitle {
    font-size: 22px;
    font-weight: 600;
    text-transform: uppercase;
  }
  .batchInputs {
    display: flex;
    flex-direction: column;
    .ant-input[disabled] {
      background-color: ${WHITE_COLOR};
    }
    .editableBatchName,
    .editableBatchDescription {
      width: 250px;
      color: ${BLACK_COLOR};
      font-size: 18px;
      font-weight: 700;
      font-family: ${DEFAULT_FONT} !important;
      border: 0;
      border-radius: 0;
      padding: 4px 0;
      border-bottom: 1px solid #d9d9d9;
    }
    .editableBatchDescription {
      width: 310px;
      font-size: 14px;
      font-weight: 400;
      text-transform: none;
      margin-top: 12px;
    }
  }
`;

export const DataLoader = styled.div`
  width: 100%;
  text-align: center;
`;

export const FlexDiv = styled.div`
  display: flex;
  column-gap: 12px;
  pointer-events: ${({isLoading}) => isLoading ? "none" : "all"};
  opacity: ${({isLoading}) => isLoading ? ".5" : "1"};
`;

export const Card = styled.div`
  display: flex;
  justify-content: ${props => (props.justifyContent ? props.justifyContent : 'space-between')};
  align-items: ${props => (props.alignItems ? props.alignItems : 'center')};
  flex-direction: ${props => (props.flexDirection ? props.flexDirection : 'column')};
  background: ${props => (props.bgColor ? props.bgColor : WHITE_COLOR)};
  height: ${props => props.height};
  width: ${props => props.width};
  padding: ${props => (props.padding ? props.padding : '0px')};
  border-radius: ${props => (props.borderRadius ? props.borderRadius : '24px')};
  cursor: ${props => props.cursorPointer && 'pointer'};
  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
  outline: ${props => props.selected ? `2px solid ${DARK_RED}` : ""};
  overflow: hidden;
  position: relative;
  animation: ${props => props.animation && slideUp} ${props => props.animationDelay} ease;
  border: ${props => props.selected && `2px outset ${LIGHT_RED}`};

  &.createBatchCard {
    align-items: normal;
  }

  &.hoverScale {
    transition: scale 0.2s ease-in-out;
    &:hover {
      scale: 1.1;

      p {
        text-decoration: underline;
      }
    }
  }

  //FAILURE COUNT & DELETE DOCUMENTS CARDS
  .failureCount,
  .deleteDocuments {
    p {
      font-size: 12px;
    }
  }
  .failureCount {
    h3 {
      color: ${DARK_RED};
      font-size: 16px;
      font-weight: 700;
      .ant-spin-dot-item {
        background-color: ${DARK_RED};
      }
    }
  }
  .failureIcon {
    svg {
      padding-top: 4px;
      width: 28px;
      height: 32px;
    }
  }
  .deleteDocuments {
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    row-gap: 8px;
    color: ${BLACK_COLOR};
    svg {
      color: ${DARK_RED};
      width: 20px;
      height: 20px;
    }
  }

  //BATCH LIST CARDS DESIGN
  .createCard {
    width: 100%;
    text-align: left;
  }
  .anticon {
    color: rgb(255, 51, 51);
  }
  .ant-btn {
    color: ${BLACK_COLOR};
    font-family: ${DEFAULT_FONT}, sans-serif !important;
    font-weight: 600;
  }
  .ant-btn:first-child {
    border-radius: 8px;
  }
  .ant-btn:last-child {
    font-size: 0.8rem;
    border-radius: 10px;
  }
  .createBatchTitle {
    padding: 6px 0;
    font-size: 0.9rem;
    font-weight: 600;
  }
  .createBatchDescription {
    font-size: 0.8rem;
  }
  .ant-progress {
    display: block;
  }
  .ant-progress-outer {
    display: block;
  }
  .ant-progress-inner {
    display: block;
    height: 6px;
    border-radius: 0;
  }
  .createdOn {
    font-size: 0.7rem;
    color: #737373;
    font-weight: 600;
  }

  &.batchCard {
    * {
     color: rgba(0, 0, 0, 0.65);
    }
  }

  .batchTitle {
    font-size: 1.2rem;
    font-weight: 600;
    text-align: center;
    :hover {
      cursor: pointer;
      text-decoration: underline;
      text-underline-position: under;
    }
  }
  .batchDescription {
    width: 280px;
    font-size: 0.8rem;
    font-style: italic;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    padding: 0 8px;
    text-align: center;
  }
  .batchDetails {
    display: flex;
    flex-direction: column;
    row-gap: 6px;
    width: 100%;
    padding: 0 38px;
    div {
      display: grid;
      grid-template-columns: 28px 56px auto;
      svg {
        height: 18px;
        width: 18px;
      }
      p {
        font-size: 0.8rem;
        max-width: 175px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        :nth-child(2) {
          font-weight: 700;
        }
      }
    }
  }
  .batchStats {
    display: flex;
    justify-content: center;
    column-gap: 1px;
    div {
      background-color: ${props =>
        props.status === 'exception'
          ? LIGHT_RED
          : props.status === 'active'
          ? LIGHT_BLUE
          : props.status === 'success' && LIGHT_GREEN};
      padding: 8px 0;
      width: 80px;
      text-align: center;
    }
    div:first-child {
      border-radius: 10px 0 0 10px;
    }
    div:last-child {
      border-radius: 0 10px 10px 0;
    }
    h2 {
      font-size: 1rem;
      font-weight: 700;
      color: ${props =>
        props.status === 'exception'
          ? DARK_RED
          : props.status === 'active'
          ? DARK_BLUE
          : props.status === 'success' && DARK_GREEN};
    }
    p {
      font-size: 0.7rem;
      text-transform: uppercase;
    }
  }
  .appliedFilterButton {
    background-color: ${WHITE_COLOR};
    border: 0;
    outline: 0;
    padding: 12px 0;
    position: relative;
    font-weight: 600;
    span {
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translate(-50%, -50%);
      font-size: 0.7rem !important;
      font-family: ${DEFAULT_FONT} !important;
      width: max-content;
      z-index: 2;
      :hover {
        cursor: pointer;
        text-decoration: underline;
        text-underline-position: under;
      }
    }
  }
  .appliedFilters {
    position: absolute;
    top: 0;
    height: 100%;
    width: 100%;
    z-index: 1;
    background-color: rgba(255, 255, 255, 94%);
    transform: translateY(100%);
    transition: transform 300ms ease;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    padding: 24px;
    border-radius: 24px;
    table {
      font-size: 0.8rem;
      th {
        font-weight: 700;
        text-decoration: underline;
        text-underline-position: under;
      }
      tr {
        .tagsList {
          display: flex !important;
          align-items: center;
          justify-content: flex-start;
          flex-wrap: wrap;
          row-gap: 2px;
        }
        td {
          padding: 2px 0;
          font-size: 0.8rem;
          .moreTags {
            font-size: 10px;
            padding: 6px 5px;
            border-radius: 8px;
            white-space: nowrap;
            background-color: ${LIGHT_GREEN};
          }
          .tags {
            font-size: 0.7rem;
            margin-right: 5px;
            padding: 6px 10px;
            border-radius: 8px;
            line-height: normal;
            background-color: ${LIGHT_GREEN};
          }
        }
        td:nth-child(1) {
          font-weight: 700;
        }
      }
    }
  }
  .appliedFilterButton:hover + .appliedFilters {
    transform: translateY(0%);
  }

  //DOCUMENTS LIST CARDS DESIGN
  .styledDiv {
    height: 106px;
    width: 106px;
    position: absolute;
    left: -35px;
    transform: rotate(45deg);
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 22px;
    padding: 0 0 20px 20px;
    background-color: ${props => props.randomColor};
    svg {
      height: 32px;
      width: 32px;
      transform: rotate(-45deg);
    }
  }
  .textContainer {
    padding-left: 82px;
    margin: auto 0;
    width: 94%;
  }
  .date {
    font-size: .8rem;
    font-weight: 600;
    color: #B5B2B2;
  }
  .docName {
    font-size: 15px;
    font-weight: 700;
    letter-spacing: 0.25px;
    display: flex;
    align-items: center;
    .name {
      font-size: 15px;
      font-weight: 700;
      letter-spacing: 0.25px;
      max-width: 175x;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      a {
        color: ${BLACK_COLOR}A6;
        text-decoration: none;

        :hover {
          text-decoration: underline;
        }
      }
    }
  }
  .pageCount {
    float: right;
    background: #f2f2f2;
    display: flex;
    align-items: center;
    column-gap: 4px;
    padding: 4px 8px;
    border-radius: 8px;
    display: flex;
    margin-top: 8px;
    p {
      font-size: 10px;
    }
  }
  svg {
    height: 16px;
    width: 16px;
  }

  //PRINTER LIST CARD DESIGN
  .printerIcon {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 58px;
    width: 58px;
    background-color: ${props => props.color};
    border-radius: 10px;
    svg {
      height: 24px;
      width: 24px;
    }
  }
  .printerDetails {
    text-align: center;
    .name {
      font-size: 14px !important;
      color: ${BLACK_COLOR};
      padding: 4px 0;
      font-weight: 700;
    }
    .ipAddress {
      font-size: 12px !important;
      letter-spacing: 0.25px;
      color: #a7a4a4;
      font-weight: 600;
    }
  }
`;

export const DataContainer = styled.div`
  position: relative;
  height: ${props => props.height};
  width: ${props => (props.width ? props.width : '100%')};
  .fade-enter {
    opacity: 0;
    transform: translateX(100%);
  }
  .fade-enter-active {
    opacity: 1;
    transform: translateX(0%);
  }
  .fade-exit {
    opacity: 1;
    transform: translateX(0%);
  }
  .fade-exit-active {
    opacity: 0;
    transform: translateX(-100%);
  }
  .fade-enter-active,
  .fade-exit-active {
    transition: opacity 300ms, transform 300ms;
  }
`;

const slideUp = keyframes`
from {
  opacity: 0;
  transform: translateY(100%);
} to {
  opacity: 1;
  transform: translateY(0%);
}`;

const fadeText = keyframes`
   from {
     opacity: 0;
     transform: translate3d(0, 100%, 0);
   }
   to {
     opacity: 1;
     transform: none;
   }
 `;

export const MenuDrawer = styled.div`
  position:${props => (props.SearchDrawer ? 'relative' : 'absolute')};
  display: ${props => (props.SearchDrawer ? 'block' : 'flex')};
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-left:${props => (props.SearchDrawer ? '' : '100%')};
  right:${props => props.SearchDrawer && '0'};
  z-index:200;
  top:0;
  right: -25%;
  width: 0;
  height:100vh;
  transition: all 0.5s ease-in-out;

  @media only screen and (max-width: 465px) {
    top: 85px;
    margin-left:0;
    width: 100vw;
    height: 100vh;
  }
  .menus{
    align-items: flex-start;
    justify-content: center;
    display: flex;
    flex-direction: column;
  }
  p,.option {
    font-size: 20px;
    cursor:pointer;
    font-family:'Open Sans', sans-serif;
    font-weight: 300;
    line-height: 2;
    text-transform:uppercase;
    @media only screen and (min-width: 1460px) {
      font-size: 26px;
    }
    @media only screen and (min-width: 2560px) {
      font-size: 35px;
    }
    @media only screen and (max-width: 768px) {
      font-size:16px;
    }
  }

  &.drawVisible{
    width: 25%;
    right: 0;
    visibility: visible;
    .option {
      position: relative;
      opacity: 0;
      font-family:'Open Sans', sans-serif;
      -webkit-animation: ${fadeText} 1s ease-in-out 0s forwards;
      animation: ${fadeText} 1s ease-in-out 0s forwards;
      display: flex;
      flex-direction: row;
      align-items: center;
      -webkit-animation-delay: .1s;
      animation-delay: .1s;
    }
    .option:hover{
    .arrow {
      background: #000;
      height: 2px;
      width: 16px;
      position:absolute;
      left: 100%;
      cursor: pointer;
      margin-left:15px;
      transition: .2s ease-in-out !important;
      &:before,
      &:after {
        content: "";
        background: #000;
        position: absolute;
        height: 2px;
        width: 12px;
      }
      &:before {
        right: -4px;
        bottom: -4px;
        transform: rotate(-45deg);
      }
      &:after {
        right: -4px;
        top: -4px;
        transform: rotate(45deg);
      }
      @media only screen and (min-width: 1460px) {
        height:2.5px;
        width: 25px;
      }
      @media only screen and (min-width: 2560px) {
        width:40px;
        &:before{
          width:20px;
          right: -6px;
          bottom: -6px;
        }
        &:after {
          width:20px;
          right: -6px;
          top: -6px;
        }
      }
    }
    }
  }

  &.drawInVisible  {
    width: 0;
    right: -25%;
    visibility: hidden;
  }
  .switch_test+.box {
    opacity: 1;
    right: 0%;
  }

  .switch_test+.box::after {
    animation: bounce-color steps(1) 1s 1, bounce-size linear 1s 1;
  }

  .box {
    display: flex;
    justify-content: center;
    background: ${palette.APP_BRAND_YELLOW_COLOR};
    padding: 24px 12px;
    position: absolute;
    bottom: 0;
    left: 0;
    top: 0;
    right: 70%;
    opacity: 0;
    transition: all 0.5s;
  }

  .box::after {
    content: '';
    position: absolute;
    right: 100%;
    top: 0;
    bottom: 0;
    border-radius: 100%;
  }

  @keyframes bounce-size {
    0% {
      width: 0;
      right: 0;
    }
    10% {
      width: 32%;
      right: -16%;
    }
  20% {
      width: 0;
    right: 0;
  }
  30% {
     width: 16%;
    right: -8%;
  }
  40% {
     width: 0;
    right: 0;
  }
  50% {
     width: 8%;
    right: -4%;
  }
  60% {
     width: 0;
    right: 0;
  }
  70% {
     width: 4%;
    right: -2%;
  }
  80% {
     width: 0;
    right: 0;
  }
  90% {
     width: 2%;
    right: -1%;
  }
  100% {
     width: 0;
    right: 0;
  }
}
@keyframes bounce-color {
  0% {
    background-color: #fff;
  }
  20% {
    background-color: ${palette.APP_BRAND_YELLOW_COLOR};
  }
  40% {
    background-color: #fff;
  }
  60% {
    background-color: ${palette.APP_BRAND_YELLOW_COLOR};
  }
  80% {
    background-color: #fff;
  }
  100% {
    background-color: ${palette.APP_BRAND_YELLOW_COLOR};
  }
}

  .switch_searchBar+.searchDrawer {
    opacity: 1;
    left: 0%;
  }

  .switch_searchBar+.searchDrawer::after {
    -webkit-animation: bounce-color-search steps(1) 1s 1, bounce-size-search linear 1s 1;
    animation: bounce-color-search steps(1) 1s 1, bounce-size-search linear 1s 1;
  }

  .searchDrawer {
    background:${props => (props.isBatch ? '#fff' : 'rgb(37,41,45)')};
    position: relative;
    padding:12px;
    height: 100vh;
    opacity: 0;
    -webkit-transition: all 0.5s;
    transition: all 0.5s;
  }

  .searchDrawer::after {
    content: '';
    position: absolute;
    right: 100%;
    top: 0;
    bottom: 0;
    border-radius: 100%;
  }
@keyframes bounce-size-search {
  0% {
    width: 0;
    left: 0;
  }
  10% {
     width: 32%;
    left: -16%;
  }
  20% {
     width: 0;
    left: 0;
  }
  30% {
     width: 16%;
    left: -8%;
  }
  40% {
     width: 0;
    left: 0;
  }
  50% {
     width: 8%;
    left: -4%;
  }
  60% {
     width: 0;
    left: 0;
  }
  70% {
     width: 4%;
    left: -2%;
  }
  80% {
     width: 0;
    left: 0;
  }
  90% {
     width: 2%;
    left: -1%;
  }
  100% {
     width: 0;
    left: 0;
  }
}
@keyframes bounce-color-search {
  0% {
    background-color: #fff;
  }
  20% {
    background-color: #fff;
  }
  40% {
    background-color: #fff;
  }
  60% {
    background-color: #fff;
  }
  80% {
    background-color: #fff;
  }
  100% {
    background-color: #fff;
  }
}
  .ant-calendar-range-picker-input:placeholder-shown {
    font-size: 0.7rem !important;
  }
  .ant-calendar-range-picker-input {
    font-size: 0.7rem !important;
  }
  .ant-calendar-range-picker-input[disabled]{
    color: #141414;
  }
`;

export const AdvSearchIcon = styled(Icon)`
  position: absolute;
  top: ${props => (props.showSearchIcon ? '0' : '190px')};
  right: 0;
  display: inline;
  z-index: ${props => (props.showSearchIcon ? '0' : '10')};
  background: rgb(37, 41, 45);
  box-shadow: ${props => (!props.closeIcon ? '' : '0 1rem 3rem rgba(0, 0, 0, 0.175)')};
  padding: 20px;
  border-top-left-radius: 50%;
  border-bottom-left-radius: 50%;
  color: #fff;
  transition: right 1s ease-in-out;
`;

export const ContentSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  justify-content: flex-start;
  padding-top: ${props => props.isBatch && '50px'};
  .ant-select {
    width: 275px !important;
  }
  .ant-select-selection--multiple {
    min-height: 35px;
  }
  .ant-calendar-picker {
    width: 100% !important;
  }
  .ant-checkbox-group {
    width: 100%;
    max-height: 190px;
    @media only screen and (min-width: 1460px) {
      max-height: 290px;
    }
  }
  .ant-checkbox-group-item {
    width: 100%;
    @media only screen and (min-width: 1460px) {
      padding: 5px;
      padding-left: 0 !important;
    }
  }
  .ant-checkbox + span {
    padding-right: 8px;
    padding-left: 8px;
    font-family: Raleway, sans-serif;
    font-size: 10px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 2px;
    fill: #585858;
    color: #fff;
    background-color: rgba(0, 0, 0, 0);
    border-radius: 0px 0px 0px 0px;
    @media only screen and (min-width: 1460px) {
      font-size: 12px;
    }
  }
  .ant-checkbox-checked .ant-checkbox-inner {
    background: linear-gradient(to right, #ef9d43, #e75516);
    border-color: rgb(219, 57, 31);
    border: 2px solid rgb(219, 57, 31) !important;
  }
  .ant-checkbox-checked::after {
    border-color: rgb(219, 57, 31);
    border: 1px solid rgb(219, 57, 31);
  }
  .ant-divider-horizontal {
    margin: 10px 0px;
  }
  .ant-checkbox-wrapper {
    text-align: left;
    width: 100%;
  }
  .ant-checkbox-wrapper + .ant-checkbox-wrapper {
    margin-left: 0 !important;
  }
  .button {
    height: 100%;
    display: flex;
    align-items: center;
  }
  .anticon.anticon-loading {
    color: #fff;
    font-size: 30px;
    padding: 20px;
  }
  .ant-select-tree-treenode-selected {
    display: none;
  }
`;

export const SearchTitle = styled.div`
  font-size: 30px !important;
  color: #fff !important;
  text-transform: capitalize;
  font-weight: 400;
  margin: 0 !important;
  text-align: center;
  font-family: ${palette.FONT_FAMILY_TEMPLATE};
  background: ${props => props.isBatch && 'rgb(37,41,45)'};
  position: ${props => props.isBatch && 'absolute'};
  top: ${props => props.isBatch && '0'};
  width: ${props => props.isBatch && '100%'};
  @media only screen and (min-width: 2560px) {
    font-size: 50px !important;
  }
  @media only screen and (min-width: 1460px) {
    font-size: 40px !important;
  }
`;

export const FilterTitle = styled.div`
  color: #fff;
  font-size: 11px;
  font-family: 'Roboto', sans-serif;
  font-weight: 600;
  text-transform: uppercase;
  // line-height: 40px;
  margin: ${props => (props.isDate ? '10px' : '15px')};
  letter-spacing: 1px;
  text-align: left;
  width: 100%;
  @media only screen and (min-width: 1460px) {
    font-size: 14px;
    margin: 20px;
  }
`;

export const SendLetterTitle = styled.div`
  font-size: 30px !important;
  color: black;
  text-transform: capitalize;
  font-weight: 400;
  margin: 0 !important;
  text-align: center;
  font-family: ${palette.FONT_FAMILY_TEMPLATE};
  background: ${props => props.isBatch && 'rgb(37,41,45)'};
  position: ${props => props.isBatch && 'absolute'};
  top: ${props => props.isBatch && '0'};
  width: ${props => props.isBatch && '100%'};
  padding-top: 25px;
  @media only screen and (min-width: 2560px) {
    font-size: 50px !important;
  }
  @media only screen and (min-width: 1460px) {
    font-size: 40px !important;
  }
`;

export const BulkUploadButton = styled.div`
  border: 1px dotted #949494;
  border-radius: 5px;
  margin: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  font-size: ${props => (props.isUploading ? '11px' : '11px')};
  font-weight: ${props => props.isUploading && '700'};
  width: 85%;
  text-align: center;
  @media only screen and (min-width: 2560px) {
    padding: 300px;
    height: 700px !important;
  }
  @media only screen and (min-width: 1460px) {
    height: 450px !important;
    padding: 150px;
  }
  @media only screen and (max-width: 1360px) {
    padding: 55px !important;
  }
  .downloadZip {
    cursor: pointer;
  }
  div {
    display: flex;
    align-items: center;
    justify-content: center;
    .anticon {
      font-size: 45px;
      color: #000000;
    }
  }
  .import {
    font-size: 14px;
    font-weight: 700;
  }
  p.desc {
    font-size: 11px;
    text-transform: initial;
    font-weight: 400;
    color: #979696;
  }
`;
